import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const CustomersAndOrdersViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

export const CustomerDetailViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersDetailsView],
  },
]

export const OrderDetailViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersOrderDetailView],
    // TODO: Change to specific order details permission once it's added
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

export const CustomerSearchViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersCustomerSearchView],
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]
